module.exports = __webpack_public_path__ + "static/collaboration-bg-f6db0660ecd6165438634c8b24187fc3.png";